export default {    
    SET_NAME: async (context, name) => {               
        context.commit('SET_NAME', name);
    },

    //CATEGORY
    SET_CATEGORY_DESCRIPTION: async (context, text) => {               
        context.commit('SET_CATEGORY_DESCRIPTION', text);
    },

    SET_CATEGORY_IMAGES: async (context, image) => {               
        context.commit('SET_CATEGORY_IMAGES', image);
    },
    //END CATEGORY

    //HTML EDITOR
    INIT_HTML_EDITOR: async (context, htmlEditorEntity) => {               
        context.commit('INIT_HTML_EDITOR', htmlEditorEntity);
    },
    INIT_HTML_EDITOR_SET_TEXT: async (context, text) => {               
        context.commit('INIT_HTML_EDITOR_SET_TEXT', text);
    },    
    //END HTML EDITOR

    //ARTICLE
    SET_ARTICLE_DESCRIPTION: async (context, text) => {               
        context.commit('SET_ARTICLE_DESCRIPTION', text);
    },
    //END ARTICLE

    //COMMENT
    SET_COMMENT_DESCRIPTION: async (context, text) => {               
        context.commit('SET_COMMENT_DESCRIPTION', text);
    },
    //END COMMENT

    //LANGUAGE ENTITY
    INIT_LANGUAGE_ENTITY: async (context, languageEntity) => { 
        context.commit('INIT_LANGUAGE_ENTITY', languageEntity);
    },
    //END LANGUAGE ENTITY  
    
    //INIT SITE DATA
    INIT_SITE_DATA: async (context, siteData) => {       
        context.commit('INIT_SITE_DATA', siteData);
    },
    //END INIT SITE DATA

    //INIT LANGUAGE SOURCE
    INIT_LANGUAGE_SOURCE: async (context, sourceJson) => {           
        context.commit('INIT_LANGUAGE_SOURCE', sourceJson);
    },
    //END INIT LANGUAGE SOURCE

    //SET CURRENT LANGUAGE
    SET_CURRENT_LANGUAGE: async (context, selectedLanguage) => {             
        context.commit('SET_CURRENT_LANGUAGE', selectedLanguage);
    },
    //END SET CURRENT LANGUAGE

    //LOGIN USER
    SET_LOGIN_USER: async (context, user) => {             
        context.commit('SET_LOGIN_USER', user);
    },    
    //END LOGIN USER
}
